module.exports = __webpack_public_path__ + "img/logo_Safari.8a17672b.png";